import { drawerCssVars, Stack } from '@cast/design-system';

import type { StackProps } from '@cast/design-system';

/** @deprecated This is intended for use with legacy drawers. For use with DrawerBody, import DrawerContent from '@cast/design-system'  */
export const DrawerContent = ({
  testId,
  ...props
}: StackProps & { testId?: string }) => {
  return (
    <Stack
      mx={drawerCssVars.getters.horizontalPadding()}
      data-testid={testId}
      {...props}
    />
  );
};
